import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';

import { oms } from '../models/models.generated';
import { ApiHttpClient } from 'src/app/infrastructure/services/api-http-client';

@Injectable({
    providedIn: 'root'
})
export class PrivilegesApiService {
    private privileges$: Observable<oms.OmsPrivileges>;

    constructor(private http: ApiHttpClient) {
        this.privileges$ = this.http.get<oms.OmsPrivileges>('privileges', false).pipe(
            publishReplay(1),
            refCount()
        );
    }

    public get(): Observable<oms.OmsPrivileges> {
        return this.privileges$;
    }
}
